<style scoped lang="scss" type="text/scss">
    .angle-hover-card-container {
        border: .1rem solid transparent;
        position: relative;
        margin-bottom: .5rem;

        &:last-of-type {
            margin-bottom: 0;
        }

        .angle {
            background-color: transparent;
            position: absolute;
            width: .3rem;
            height: .3rem;
            border: .1rem solid transparent;
            transform: rotate(45deg);
            top: calc(50% - .15rem);
            right: -.25rem;
            transition: all .2s;
        }

        opacity: .5;
        color: #666;
        transition: all .2s;

        &.active, &:hover {
            opacity: 1;

            .angle {
                background-color: #F4F4F4;
                border-top-color: #3E9EFF;
                border-right-color: #3E9EFF;
            }
        }

        &:hover {
            cursor: pointer;
        }

        border-radius: .15rem;
    }
</style>

<template>
    <border-active-block class="angle-hover-card-container" :active="active" :class="{'active': active}">
        <div class="angle" v-if="withAngle"></div>
        <slot></slot>
    </border-active-block>
</template>

<script>
    import BorderActiveBlock from '../border-active-block/index';

    export default {
        name: '',
        components: {
            BorderActiveBlock
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
            withAngle: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {};
        }
    };
</script>
